module.exports = __webpack_public_path__ + "static/media/throphy1.8a18677e.png";